var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.averages[0].data.length)?_c('apexchart',{staticClass:"apexchart apexchart-averages",attrs:{"type":"line","height":"200","options":_vm.options,"series":_vm.averages}}):_c('div',{staticClass:"text-center d-flex align-center justify-center",staticStyle:{"height":"200px"}},[_vm._v(" لا توجد بيانات لعرضها ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }